import { jsx as ___EmotionJSX } from "@emotion/core";
import React, { createContext } from 'react';
import { AuthProvider } from '../authentication/components/AuthProvider';
import { LocalizationProvider } from '../localization/LocalizationProvider';
import { ApolloProvider } from '@apollo/react-hooks';
import { createContentfulApolloClient } from '../resources';
import { I18nProvider } from '../localization';
export var BusinessComponentsContext = createContext({
  locale: 'en'
});

var BusinessComponentsProvider = function BusinessComponentsProvider(_ref) {
  var locale = _ref.locale,
      oktaConfig = _ref.oktaConfig,
      children = _ref.children;
  var contentfulConfig = {
    spaceId: 'z860498abl84',
    //'ctgexfj9tq93',
    token: 'e_Xv9BwAngDdJalBwfJlRYe-NY0OhkJl-cOaRqVuKWg',
    //'EvMTkI5jvsZYrbzFINJu1yKu67o83OXdq2G4Tn9ZEr8',
    environment: 'master'
  };
  var client = createContentfulApolloClient(contentfulConfig);
  return ___EmotionJSX(BusinessComponentsContext.Provider, {
    value: {
      locale: locale
    }
  }, ___EmotionJSX(LocalizationProvider, {
    initialLocale: locale
  }, ___EmotionJSX(I18nProvider, null, ___EmotionJSX(AuthProvider, {
    config: oktaConfig
  }, ___EmotionJSX(ApolloProvider, {
    client: client
  }, children)))));
};

export default BusinessComponentsProvider;